import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import { ArrowDropDown } from '@material-ui/icons';

import { colors } from '../../themes/colors';

const styles = () => ({
  panelRoot: {
    padding: '0 16px',
    borderTop: `solid 1px ${colors.gray1}`,
    '&:before': {
      opacity: '0 !important',
    },
  },
  panelExpanded: {
    margin: '0 !important',
    '&:before': {
      opacity: '0 !important',
    },
  },
  panelSummary: {
    padding: 0,
  },
  panelSummaryExpanded: {
    minHeight: 'initial !important',
  },
  panelSummaryContent: {
    margin: '20px 0px !important',
  },
  expandMoreIcon: {
    right: 0,
    color: colors.black3,
  },
  panelTitle: {
    color: colors.black3,
    fontFamily: 'Avenir-Black',
    fontSize: 16,
  },
  panelDetails: {
    marginTop: -15,
    paddingLeft: 5,
    paddingRight: 5,
    flexDirection: 'column',
    paddingBottom: 10,
  },
});

const MembersSettingsPanel = ({ classes, title, children }) => (
  <Accordion elevation={0} classes={{ root: classes.panelRoot, expanded: classes.panelExpanded }}>
    <AccordionSummary
      expandIcon={<ArrowDropDown />}
      className={classes.panelSummary}
      classes={{
        expandIcon: classes.expandMoreIcon,
        expanded: classes.panelSummaryExpanded,
        content: classes.panelSummaryContent,
      }}
    >
      <Typography className={classes.panelTitle}>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails className={classes.panelDetails}>
      <React.Fragment>{children}</React.Fragment>
    </AccordionDetails>
  </Accordion>
);

export default withStyles(styles)(MembersSettingsPanel);
